import { getPropsFromNode, nodeIs, nodeListToArray } from '../utils'
import { h } from '../parser/utils'

export const NAME = 'title-list'

export const COMPONENTS = {}

export function matches(node) {
  if (!nodeIs(node, 'ul', 'ol')) {
    return false
  }

  const listEntries = nodeListToArray(node.querySelectorAll(':scope > li'))

  return !listEntries.some(node => {
    const length = node.querySelectorAll(':scope > .title').length
    return length === 0
  })
}

async function parseEntry(node, next, ctx) {
  const termChildrenPromises = []
  const definitionChildrenPromises = []

  nodeListToArray(node.childNodes).forEach(child => {
    if (child?.matches?.('.title')) {
      termChildrenPromises.push(
        next(child.childNodes, ctx),
      )
    } else {
      definitionChildrenPromises.push(
        next([child], ctx),
      )
    }
  })

  const termChildren = await Promise.all(termChildrenPromises)
  const definitionChildren = await Promise.all(definitionChildrenPromises)

  return [
    h('dt', {}, ...termChildren.flat()),
    h('dd', {}, ...definitionChildren.flat()),
  ]
}

export async function transform (node, next, ctx) {
  const entries = nodeListToArray(
    node.querySelectorAll(':scope > li'),
  )

  const children = await Promise.all(entries.map(node => parseEntry(node, next, ctx)))

  const props = getPropsFromNode(node)

  return h(
    'dl',
    props,
    ...children.flat(),
  )
}
